export default {
    PtFieldManagerPanel: {
        avaliableFields: '可選字段',
        displayFields: '顯示字段',
        patentFields: '專利字段',
        customFields: '自定義字段',
        searchPlaceholder: '查找字段',
        noData: '沒有當前類型字段',
        searchNoData: '未查找到相關字段',
        spaceScopeFieldTip: '標引值僅對當前空間生效',
    },
};
